<template>
  <div class="footer-container">
    <div class="footer-container--top">
      <div class="container-logo">
        <svg class="full__logo" viewBox="0 0 36 56" xmlns="http://www.w3.org/2000/svg">
          <path d="m5.23886 25.9358h.9679c.25679 0 .45432-.1975.45432-.4543v-.7704c0-1.0074-.25679-1.7975-.75062-2.3506s-1.22469-.8099-2.19259-.8099-1.69877.2765-2.19259.8099c-.49383.5531-.750622 1.3234-.750622 2.3506v6.5383c0 1.0074.256792 1.7975.750622 2.3506.49382.5531 1.22469.8099 2.19259.8099s1.69876-.2766 2.19259-.8099c.49383-.5531.75062-1.3235.75062-2.3506v-3.5358c0-.2568-.19753-.4544-.45432-.4544h-1.87655c-.25679 0-.45432.1976-.45432.4544v.8889c0 .2567.19753.4543.45432.4543s.45433.1975.45433.4543v1.8765c0 .4544-.09877.7704-.27655.9482s-.43457.2765-.75061.2765c-.31605 0-.55309-.0987-.75062-.2765-.17778-.1778-.27655-.4938-.27655-.9482v-6.795c0-.4543.09877-.7704.27655-.9679.17778-.1778.43457-.2766.75062-.2766.31604 0 .55308.0988.75061.2766.17778.1778.27655.5136.27655.9679v.8889c0 .2568.19753.4543.45432.4543z"></path>
          <path d="m9.24864 22.3802c-.51358.5531-.77037 1.3235-.77037 2.3507v6.5382c0 1.0074.25679 1.7976.77037 2.3507.51358.553 1.26416.8098 2.23206.8098s1.7186-.2765 2.2321-.8098c.5136-.5531.7704-1.3235.7704-2.3507v-6.5382c0-1.0074-.2568-1.7976-.7704-2.3507-.5135-.553-1.2642-.8098-2.2321-.8098s-1.71848.2765-2.23206.8098zm3.25926 2.2124v6.7753c0 .4543-.0988.7704-.2765.9679-.1778.1778-.4346.2765-.7507.2765-.316 0-.553-.0987-.7506-.2765-.1778-.1778-.2765-.5136-.2765-.9679v-6.7753c0-.4543.0987-.7704.2765-.9679.1778-.1778.4346-.2765.7506-.2765.3161 0 .5531.0987.7507.2765.1777.1975.2765.5136.2765.9679z"></path>
          <path d="m16.9128 21.7086c-.2568 0-.4543.1976-.4543.4543v11.6544c0 .2568.1975.4543.4543.4543h1.0864c.2568 0 .4544-.1975.4544-.4543v-11.6544c0-.2567-.1976-.4543-.4544-.4543z"></path>
          <path d="m22.1277 21.7086h-1.0865c-.2568 0-.4543.1976-.4543.4543v11.6544c0 .2568.1975.4543.4543.4543h1.0865c.2567 0 .4543-.1975.4543-.4543v-3.2988c0-.079.0197-.1383.0592-.2173l.0988-.1778c.1778-.3358.6716-.316.8099.0593l1.4617 3.7926c.0593.1778.237.2963.4148.2963h1.0667c.316 0 .5333-.3161.4148-.6124l-2.4296-6.1629c-.0395-.1185-.0395-.2568.0197-.3556l2.3506-4.7802c.1383-.2963-.079-.6519-.395-.6519h-.9679c-.1778 0-.3358.0988-.4148.2568l-2.4297 5.1753h-.0395v-4.9975c-.0395-.2371-.237-.4346-.474-.4346z"></path>
          <path d="m29.2191 22.3802c-.5136.5531-.7704 1.3235-.7704 2.3507v6.5382c0 1.0074.2568 1.7976.7704 2.3507.5136.553 1.2642.8098 2.2321.8098s1.7185-.2765 2.2321-.8098c.5136-.5531.7704-1.3235.7704-2.3507v-6.5382c0-1.0074-.2568-1.7976-.7704-2.3507-.5136-.553-1.2642-.8098-2.2321-.8098s-1.7185.2765-2.2321.8098zm3.2593 2.2124v6.7753c0 .4543-.0988.7704-.2766.9679-.1778.1778-.4345.2765-.7506.2765-.316 0-.5531-.0987-.7506-.2765-.1778-.1778-.2766-.5136-.2766-.9679v-6.7753c0-.4543.0988-.7704.2766-.9679.1778-.1778.4346-.2765.7506-.2765.3161 0 .5531.0987.7506.2765.1778.1975.2766.5136.2766.9679z"></path>
          <path d="m32.7154 36.9778h-6.1433c-1.4419 0-2.6271 1.0469-2.7654 2.4494 0 .0592 0 .0987-.0197 2.9629 0 .3161-.1383.6124-.3556.8494-.237.237-.5728.3753-.9679.3753-.0197 0-.0395 0-.0395 0-.3556 0-.6914-.1383-.9481-.3753-.2371-.237-.3556-.5333-.3556-.8494v-2.6271c0-1.5013-1.3432-2.7655-2.9235-2.7655h-1.2049c-1.521 0-2.7852 1.2445-2.7852 2.7852v6.4395c0 .3161-.1383.6124-.3555.8494-.2568.2568-.5926.3753-.9877.3753-.3753 0-.7111-.1185-.9679-.3753-.237-.237-.3555-.5333-.3555-.8494 0-6.6568 0-6.716-.0198-6.7753-.1383-1.3629-1.3432-2.4494-2.76543-2.4494h-6.26173c-.69136 0-1.34321.2963-1.817287.7902-.474074.5135-.7111119 1.2049-.67160569 1.8963.33580269 4.7604 1.85679269 8.6123 4.50370269 11.3975 3.08148 3.2592 7.48645 4.9185 13.07655 4.9185s9.9951-1.6593 13.0765-4.9185c2.647-2.805 4.1679-6.6371 4.5037-11.3975.0593-.6914-.1975-1.3828-.6716-1.8963-.4345-.5136-1.0864-.8099-1.7777-.8099zm-3.4568 12.721c-2.7062 2.8642-6.6173 4.3061-11.6346 4.3061s-8.94815-1.4419-11.63457-4.3061c-2.33086-2.4494-3.65432-5.8864-3.97037-10.1926-.01975-.1976.07901-.3358.13827-.3951.05926-.0592.17778-.158.37531-.158h6.22223c.39506 0 .75061.2765.80987.6321v6.6173c0 .8494.33581 1.6395.94816 2.2518.6321.6124 1.4815.9482 2.3506.9482.8889.0197 1.758-.3161 2.3901-.9482.6124-.6123.9482-1.4024.9482-2.2518v-6.4395c0-.4346.3555-.8099.8099-.8099h1.2049c.4741 0 .9481.3951.9481.8099v2.6271c0 .8494.3358 1.6395.9482 2.2519.6321.6123 1.4815.9481 2.3506.9481.8889.0198 1.758-.316 2.3901-.9481.6124-.6124.9482-1.4025.9482-2.2519 0-.9679 0-2.5284 0-2.8049.0592-.3556.395-.6321.7901-.6321h6.1432c.1975 0 .3161.0988.3753.158.0593.0593.158.1975.1383.3951-.3358 4.3062-1.679 7.7432-3.9901 10.1926z"></path>
          <path d="m2.49318 19.0025h30.20242c.6914 0 1.3433-.2963 1.8173-.7902.4741-.5135.7111-1.2049.6716-1.8962-.3358-4.7605-1.8568-8.59264-4.5037-11.39758-3.0814-3.25926-7.4864-4.91852-13.0765-4.91852s-9.99507 1.65926-13.07655 4.91852c-2.64692 2.80494-4.167906 6.63708-4.5037085 11.39758-.0592592.6913.1975315 1.3827.6716055 1.8962.454323.4939 1.125923.7902 1.797533.7902zm3.47654-12.72102c2.70617-2.8642 6.61728-4.30617 11.63458-4.30617s8.9481 1.44197 11.6346 4.30617c2.3308 2.44939 3.6543 5.88642 3.9703 10.19262.0198.1975-.079.3358-.1382.395-.0593.0593-.1778.1581-.3754.1581h-30.20242c-.19753 0-.31605-.0988-.37531-.1581-.05926-.0592-.15803-.1975-.13827-.395.3358-4.3062 1.65926-7.74323 3.99012-10.19262z"></path>
        </svg>
      </div>
      <div class="options-1">
        <a href="https://www.goiko.com/es/carta/"><span class="options__main--title">CARTA</span></a>
        <a href="https://www.goiko.com/es/reservas/"><span>Reservar</span></a>
        <span @click="doOrder">Hacer pedido</span>
        <a href="https://www.goiko.com/es/nuestros-restaurantes/"><span class="options__main--title">Restaurantes</span></a>
        <span>FoodTrucks</span>
        <span>Goikocina</span>
        <a href="https://www.goiko.com/es/unete-al-equipo/"><span>Únete al equipo</span></a>
      </div>
      <div class="options-2">
        <a href="https://www.goiko.com/es/conocenos/nuestra-historia/">
          <div class="text-container">
            <span class="hover-text">Conócenos</span>
          </div>
        </a>
        <a href="https://www.goiko.com/es/prensa/">
          <div class="text-container">
            <span class="hover-text">Prensa</span>
          </div>
        </a>
        <a href="https://facturas.goiko.com/">
          <div class="text-container">
            <span class="hover-text">Factura online</span>
          </div>
        </a>
        <a href="https://www.goiko.com/es/alergenos/">
          <div class="text-container">
            <span class="hover-text">Alérgenos</span>
          </div>
        </a>
        <a href="https://www.goiko.com/es/blog/">
          <div class="text-container">
            <span class="hover-text">Blog</span>
          </div>
        </a>
        <a href="https://www.goiko.com/es/rsc/">
          <div class="text-container">
            <span class="hover-text">Rsc</span>
          </div>
        </a>
        <a href="https://www.goiko.com/es/contacto/">
          <div class="text-container">
            <span class="hover-text">Contacto</span>
          </div>
        </a>
      </div>
    </div>
    <div class="social-media-container">
      <a href="https://www.facebook.com/goiko" class="social__link">
        <svg class="icon--filled" viewBox="0 0 18 18">
          <path class="icon--filled__glyph" d="M18 9C18 4.02943 13.9706 0 9 0C4.02943 0 0 4.02943 0 9C0 13.4921 3.29115 17.2155 7.59375 17.8907V11.6016H5.30859V9H7.59375V7.01719C7.59375 4.76156 8.93742 3.51562 10.9932 3.51562C11.9776 3.51562 13.0078 3.69141 13.0078 3.69141V5.90625H11.873C10.755 5.90625 10.4062 6.60006 10.4062 7.3125V9H12.9023L12.5033 11.6016H10.4062V17.8907C14.7088 17.2155 18 13.4921 18 9Z"></path>
        </svg>
      </a>
      <a href="https://twitter.com/goiko" class="social__link">
        <svg class="icon--filled" viewBox="0 0 24 20">
          <path class="icon--filled__glyph" d="M23.9528 2.56987C23.0545 2.96475 22.1031 3.22553 21.129 3.34387C22.1558 2.72759 22.9245 1.76013 23.2928 0.62062C22.3216 1.18387 21.2645 1.58394 20.1638 1.80487C19.4236 1.01396 18.443 0.489463 17.3743 0.312743C16.3055 0.136024 15.2083 0.316965 14.2529 0.827495C13.2975 1.33803 12.5373 2.1496 12.0902 3.13631C11.6431 4.12301 11.5342 5.22968 11.7803 6.28462C7.69053 6.09337 4.06504 4.12837 1.64029 1.15987C1.19889 1.91053 0.968041 2.76631 0.972035 3.63712C0.971434 4.44664 1.17074 5.24379 1.55227 5.95777C1.93379 6.67175 2.48571 7.28047 3.15903 7.72987C2.37875 7.70628 1.61547 7.49617 0.933035 7.11712V7.17637C0.932797 8.31264 1.32544 9.41404 2.04443 10.2939C2.76341 11.1738 3.7645 11.778 4.87804 12.0041C4.45623 12.1168 4.02163 12.1745 3.58504 12.1759C3.26929 12.1759 2.96779 12.1451 2.66704 12.0896C2.98393 13.0674 3.59779 13.9221 4.42317 14.5347C5.24854 15.1472 6.24437 15.4873 7.27204 15.5074C5.53084 16.871 3.38238 17.6107 1.17079 17.6081C0.779065 17.6097 0.387606 17.5876 -0.00146484 17.5421C2.2546 18.9877 4.87831 19.7551 7.55779 19.7531C16.608 19.7531 21.5535 12.2569 21.5535 5.76487C21.5535 5.55787 21.5535 5.34712 21.5378 5.13562C22.5052 4.44228 23.3389 3.57933 23.9985 2.58862L23.9528 2.56987Z"></path>
        </svg>
      </a>
      <a href="https://www.instagram.com/goiko/" class="social__link">
        <svg class="icon--filled" viewBox="0 0 24 24">
          <path class="icon--filled__glyph" d="M12.0005 0C8.7387 0 8.3322 0.01575 7.0557 0.06975C5.77395 0.13275 4.90695 0.3315 4.14195 0.6285C3.3413 0.930765 2.6162 1.40401 2.0172 2.01525C1.40426 2.61285 0.930751 3.33835 0.630453 4.14C0.333453 4.905 0.134703 5.772 0.0717031 7.05375C0.0139531 8.331 0.00195312 8.73675 0.00195312 11.9985C0.00195312 15.2603 0.0177031 15.6667 0.0717031 16.9432C0.134703 18.2213 0.333453 19.092 0.630453 19.857C0.932718 20.6577 1.40596 21.3828 2.0172 21.9818C2.6148 22.5947 3.3403 23.0682 4.14195 23.3685C4.90695 23.6618 5.7777 23.8643 7.0557 23.9272C8.33295 23.985 8.7387 23.997 12.0005 23.997C15.2622 23.997 15.6687 23.9813 16.9452 23.9272C18.2232 23.8643 19.094 23.661 19.859 23.3685C20.6596 23.0662 21.3847 22.593 21.9837 21.9818C22.5974 21.3848 23.0711 20.6591 23.3705 19.857C23.6637 19.092 23.8662 18.2213 23.9292 16.9432C23.987 15.666 23.999 15.2603 23.999 11.9985C23.999 8.73675 23.9832 8.33025 23.9292 7.05375C23.8662 5.77575 23.663 4.9005 23.3705 4.14C23.0682 3.33935 22.5949 2.61425 21.9837 2.01525C21.3868 1.40152 20.6611 0.927885 19.859 0.6285C19.094 0.3315 18.2232 0.13275 16.9452 0.06975C15.668 0.012 15.2622 0 12.0005 0ZM12.0005 2.16C15.2037 2.16 15.5862 2.17575 16.8522 2.22975C18.02 2.2845 18.656 2.4795 19.0782 2.6445C19.6002 2.83719 20.0727 3.14389 20.4612 3.54225C20.8589 3.92912 21.1644 4.40051 21.3552 4.9215C21.5202 5.34375 21.7152 5.97975 21.77 7.1475C21.8239 8.4135 21.8397 8.79675 21.8397 11.9992C21.8397 15.2017 21.824 15.585 21.7655 16.851C21.7025 18.0188 21.5075 18.6548 21.3432 19.077C21.116 19.6403 20.8624 20.034 20.444 20.46C20.0541 20.8559 19.582 21.1611 19.061 21.354C18.644 21.519 17.999 21.714 16.8267 21.7687C15.554 21.8228 15.179 21.8385 11.9675 21.8385C8.75595 21.8385 8.3817 21.8228 7.10745 21.7642C5.9397 21.7013 5.29545 21.5063 4.8732 21.342C4.3032 21.1147 3.91245 20.8612 3.49395 20.4427C3.0717 20.0205 2.8032 19.6185 2.5962 19.0597C2.4282 18.6427 2.2362 17.9977 2.17395 16.8255C2.1312 15.5677 2.11095 15.1778 2.11095 11.9813C2.11095 8.78625 2.1312 8.3955 2.17395 7.122C2.2362 5.94975 2.4282 5.30625 2.5962 4.88775C2.8032 4.317 3.07245 3.927 3.49395 3.50475C3.9117 3.087 4.3032 2.817 4.8732 2.6055C5.29545 2.44125 5.92395 2.24625 7.0962 2.18775C8.36895 2.142 8.74395 2.1255 11.951 2.1255L12.0005 2.16ZM12.0005 5.84025C11.1915 5.83995 10.3903 5.99908 9.64287 6.30853C8.8954 6.61798 8.21624 7.0717 7.64419 7.64374C7.07215 8.21578 6.61843 8.89495 6.30898 9.64242C5.99953 10.3899 5.84041 11.191 5.8407 12C5.84041 12.809 5.99953 13.6101 6.30898 14.3576C6.61843 15.1051 7.07215 15.7842 7.64419 16.3563C8.21624 16.9283 8.8954 17.382 9.64287 17.6915C10.3903 18.0009 11.1915 18.16 12.0005 18.1597C12.8094 18.16 13.6106 18.0009 14.358 17.6915C15.1055 17.382 15.7847 16.9283 16.3567 16.3563C16.9288 15.7842 17.3825 15.1051 17.6919 14.3576C18.0014 13.6101 18.1605 12.809 18.1602 12C18.1605 11.191 18.0014 10.3899 17.6919 9.64242C17.3825 8.89495 16.9288 8.21578 16.3567 7.64374C15.7847 7.0717 15.1055 6.61798 14.358 6.30853C13.6106 5.99908 12.8094 5.83995 12.0005 5.84025ZM12.0005 15.9998C9.78945 15.9998 8.0007 14.211 8.0007 12C8.0007 9.789 9.78945 8.00025 12.0005 8.00025C14.2115 8.00025 16.0002 9.789 16.0002 12C16.0002 14.211 14.2115 15.9998 12.0005 15.9998ZM19.8485 5.59425C19.8481 5.9765 19.6959 6.34296 19.4255 6.6131C19.1551 6.88326 18.7885 7.035 18.4062 7.035C18.2172 7.035 18.03 6.99777 17.8554 6.92544C17.6808 6.85311 17.5221 6.7471 17.3885 6.61345C17.2549 6.47981 17.1488 6.32115 17.0765 6.14653C17.0042 5.97191 16.967 5.78475 16.967 5.59575C16.967 5.40674 17.0042 5.21959 17.0765 5.04497C17.1488 4.87036 17.2549 4.71169 17.3885 4.57805C17.5221 4.4444 17.6808 4.33839 17.8554 4.26606C18.03 4.19373 18.2172 4.1565 18.4062 4.1565C19.199 4.1565 19.8485 4.8015 19.8485 5.59425Z"></path>
        </svg>
      </a>
      <a href="https://www.linkedin.com/company/goiko-burgers" class="social__link">
        <svg class="icon--filled" viewBox="0 0 24 24">
          <path class="icon--filled__glyph" d="M20.445 20.4533H16.8953V14.883C16.8953 13.5547 16.8675 11.8477 15.039 11.8477C13.188 11.8477 12.906 13.2885 12.906 14.7847V20.4525H9.35175V8.99925H12.7657V10.5615H12.8115C13.2885 9.65925 14.4487 8.7105 16.1798 8.7105C19.7805 8.7105 20.4487 11.0813 20.4487 14.1637V20.4525L20.445 20.4533ZM5.33625 7.434C5.06496 7.4341 4.79631 7.38068 4.54569 7.27679C4.29508 7.1729 4.06742 7.02059 3.87576 6.82858C3.6841 6.63658 3.53221 6.40864 3.42878 6.15784C3.32534 5.90704 3.27241 5.63829 3.273 5.367C3.27344 4.95866 3.39496 4.55963 3.62217 4.22034C3.84939 3.88106 4.1721 3.61677 4.54951 3.46088C4.92692 3.305 5.34208 3.26451 5.74249 3.34456C6.14291 3.4246 6.5106 3.62158 6.79907 3.91058C7.08755 4.19958 7.28385 4.56763 7.36317 4.96818C7.44249 5.36874 7.40126 5.78383 7.24468 6.16095C7.08811 6.53808 6.82323 6.86031 6.48354 7.08691C6.14384 7.31351 5.74459 7.4343 5.33625 7.434ZM7.11675 20.4533H3.555V9H7.11675V20.4533ZM22.227 0H1.77C0.79275 0 0 0.77325 0 1.73025V22.2705C0 23.2275 0.79275 24.0007 1.77 24.0007H22.2233C23.199 24.0007 24 23.2275 24 22.2705V1.73025C24 0.77325 23.199 0 22.2233 0H22.227Z"></path>
        </svg>
      </a>
    </div>
    <div id="footer__rail" class="rail__container black--rail rail--left active">
				<div class="track__container" style="animation-duration: 24s;">
					<div class="track">
						<span class="track--filled">CHORREO</span>
					</div>
					<div class="track">
						<span class="track--stroked">FOREVER</span>
					</div>
				</div>
				<div class="track__container" style="animation-duration: 24s;">
					<div class="track">
						<span class="track--filled">CHORREO</span>
					</div>
					<div class="track">
						<span class="track--stroked">FOREVER</span>
					</div>
				</div>
				<div class="track__container" style="animation-duration: 24s;">
					<div class="track">
						<span class="track--filled">CHORREO</span>
					</div>
					<div class="track">
						<span class="track--stroked">FOREVER</span>
					</div>
				</div>
    </div>
    <div class="legal-links-container">
      <div class="legal-links-container--items item">
        <a href="#">
          <router-link :to="{ name: 'data-protection' }"><span>Política de protección de datos</span></router-link>
        </a>
        <div class="middle--point"></div>
        <a href="https://www.goiko.com/bases-condiciones/">
          <span>Aviso legal</span>
        </a>
        <div class="middle--point"></div>
        <a href="https://www.goiko.com/bases-condiciones/">
          <span>Bases y condiciones</span>
        </a>
        <div class="middle--point"></div>
        <a href="#">
          <router-link :to="{ name: 'cookies-policy' }"><span>Política de cookies</span></router-link>
        </a>
      </div>
      <div class="copy item">©<b>2024 GOIKO SL</b>, <span>ALL RIGHTS RESERVED</span></div>
      <div 
        @click="scrollToTop" 
        class="scroll__top item"
      >
        <div class="mask">
          <div class="top ko">TOP</div>
        </div>
        <div class="top--icon"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BodyFooter',
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    doOrder() {
      this.scrollToTop()
      this.$router.push({name: 'modal-delivery'})
    }
  },
}
</script>

<style scoped lang="scss">

.footer-container {
  display: flex;
  flex-direction: column;
  position: relative;
  padding-top: 100px;
  transition: padding-top 0.1s;
  gap: 30px;
  overflow-x: hidden;

  a {
    text-decoration: none;
  }

  .footer-container--top {
    display: flex;
    flex-wrap: wrap;
    gap: 0px;
    padding: 0 24px;
    width: 100%;

    .container-logo {
      display: flex;
      flex-direction: column;
      margin-bottom: 2.5rem;
      width: 100%;
      svg {
        width: 65px;
      }
    }

    .options-1, .options-2 {
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    .options-1 {
      span {
        color: #000;
        cursor: pointer;
        font-size: 2rem;
        font-weight: 700;
        font-family: "Knockout";
        line-height: 3rem;
        margin-bottom: 0.25rem;
        text-transform: uppercase;
      }

      span:hover {
        color: transparent;
        -webkit-text-stroke: 2px #000;
      }
    }

    .options-2 {
      margin-top: 2rem;
      .text-container {
        color: #000;
        display: inline-block;
        position: relative;
        overflow: hidden;

        span {
          margin-bottom: 0.2rem;
        }
      }

      .hover-text {
        display: inline-block;
        position: relative;
        transition: all 0.3s ease-in-out;
        cursor: pointer;
        color: #000;
        font-size: 1rem;
        font-family: "Knockout Light", serif;
        line-height: 1.25rem;
        letter-spacing: -0.016em;
        margin-bottom: 0.5rem;
        text-transform: uppercase;
      }

      .hover-text::before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 0;
        height: 0.120rem;
        background-color: #000;
        transition: width 0.3s ease-in-out;
        transform-origin: left;
      }

      .text-container:hover .hover-text::before {
        width: 100%;
      }
    }
  }
  .social-media-container {
    display: flex;
    gap: 20px;
    padding: 0 24px;
    .social__link {
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: content-box;
      height: 1rem;
      line-height: 0;
      padding: 0.3rem;
      position: relative;
      width: 1.2rem;
      height: 1.2rem;
      background-color: #000;
      border-radius: 50%;
      border: 2px solid #000;

      svg {
        fill: #fff;
        height: 15px;
        width: 15px;
      }
    }
    .social__link:hover {
      background-color: transparent;

      svg {
        fill: #000;
      }
    }
  }
  .rail__container {
    padding: 0.75rem 0;
    border-bottom: solid 0.125rem;
    border-top: solid 0.125rem;
    display: inline-flex;
    position: relative;
    user-select: none;
    overflow: hidden;
    white-space: nowrap;
    width: auto;
    .track__container {
      animation-duration: 24s;
      animation: 15s rail-left infinite linear;
      display: inline-block;
      margin: 0;
      width: auto;
      .track {
        display: inline-block;
        position: relative;
        min-width: 7.5rem;

        span {
          font-size: 3.5rem;
          display: inline-block;
          font-weight: 600;
          font-family: "Knockout";
          line-height: 1;
          text-transform: uppercase;
        }
      }

      .track--stroked {
        color: rgba(0,0,0,0);
        -webkit-text-stroke: #000;
        -webkit-text-stroke-width: 2px;
      }
    }
    @keyframes rail-left {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(-100%);
      }
    }
  }

  .legal-links-container {
    display: flex;
    flex-direction: column;
    padding: 0 24px;
    gap: 20px;
    margin-bottom: 20px;
    flex: 1;

    &--items {
      display: flex;
      flex-direction: column;

      a {
        color: #000;
        display: block;
        text-decoration: none; 
      }

      span {
        font-size: .75rem;
        font-family: "Knockout Light", serif;
        line-height: normal;
        letter-spacing: -0.016em;
        text-transform: uppercase;
        margin-bottom: .5rem;
      }

      span:hover {
        border-bottom: 1.5px solid #000;
      }

      .middle--point {
        display: none;
      }
    }
    .scroll__top {
      display: none;
    }
    
  }
  .copy {
    font-weight: 400;
    font-size: 1rem;
    line-height: normal;
    letter-spacing: -0.016em;
    font-family: "Knockout", serif;
    font-size: .75rem;
    margin-bottom: 20px;

    b {
      font-weight: bolder;
    }

    span {
      font-family: "Knockout Light";
    }
  }

  @media only screen and (min-width: 768px) {
    justify-content: space-between;
    align-items: flex-start;
    .footer-container--top {
      .container-logo {
        svg {
          width: 6rem;
        }
      }
      .options-1 {
        margin-top: 0;
        width: 60%;
      }
      .options-2 {
        margin-top: 0;
        width: 40%;
      }
      .options-2 {
        font-size: 1.5rem;
        line-height: 1.5rem;
      }
    }
    .rail__container {
      .track__container {
        .track {
          span {
            font-size: 5rem;
          }
        }
      }
    }
    .social-media-container {
      padding: 0 40px;
      padding-bottom: .2rem;
      padding-top: 2rem;
    }
    .legal-links-container {
      flex-direction: row-reverse;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 0;
      padding-top: 0;

      &--items {
        flex-direction: row;
        flex-wrap: wrap;
        a {
          display: inline;
        }
        li {
          &::after {
            content: '·';
            display: inline-block;
            margin: 4px; 
          }

          &:last-of-type::after {
            content: '·';
            opacity: 0;
            display: inline-block;
            margin: 4px; 
          }
        }
      }
      .copy {
        width: 50%;
      }
    }
  }

  @media only screen and (min-width: 1200px) {
    .footer-container--top {
      padding: 0 40px;
      .container-logo {
        width: 40%;
      }
      .options-1 {
        width: 36%;

        span {
          font-size: 2.5rem;
          line-height: 3rem;
        }
      }
      .options-2 {
        width: 24%;

        .text-container {
          .hover-text {
            font-size: 1rem;
          }
        }
      }
    }

    .rail__container {
      padding: 1rem 0;
      .track__container {
        .track {
          span {
            font-size: 6rem;
          }
        }
      }
    }
    .legal-links-container {
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 20px;
      padding: 0 40px;
      width: 100%;
      .item {
        flex: 1;
      }
      .item:nth-child(1){
        order: 2;
        flex-grow: 2;
      }
      .item:nth-child(3){
        order: 2;
        flex-grow: 0;
      }
      &--items {
        width: 100%;
        display: flex;
        justify-content: center;

        span {
          font-size: .875rem;
        }
      }
      .copy {
        margin-bottom: 0;
      }
      .scroll__top {
        cursor: pointer;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .mask {
          position: relative;
          overflow: hidden;
          .top {
            font-weight: 700;
            font-family: "Knockout";
            margin-right: 0.5rem;
            transform: translateY(-100%);
            transition: .4s cubic-bezier(0.78, 0, 0.13, 1);
          }
        }
        .top--icon {
          background: #000;
          border: solid 0.125rem #000;
          border-radius: 50%;
          height: 0.825rem;
          width: 0.825rem;
        }
      }
      .scroll__top:hover {
        .mask {
          .top {
            transform: translateY(0);
          }
        }
        .top--icon {
          background: transparent;
          border: solid 0.125rem #000;
        }
      }
    }
  }

  ul.nav-footer-primary,
  ul.nav-footer-secondary,
  ul.nav-footer-legal {
    margin: 0;
    padding: 0;

    li {
      list-style: none;
    }
  }

  // ul.nav-footer-legal {
  //   display: flex;
  //   align-items: center;
  //   justify-content: flex-end;
  //   gap: 30px;
  // }
}
</style>
